@if (type == 'main') {
<div class="d-flex">
    @for (row of data; track $index) {
    <ul class="list-unstyled col">
        @for (sport of row; track trackByFn(i, sport); let i = $index) {
        <li>
            <a
                class="dropdown-item icon--sport icon--{{ sport.code_name }}"
                (click)="resetScroll()"
                [routerLink]="this.getRouterArr(sport)"
                routerLinkActive="text-super-emph"
            >
                <img
                    src="/img/sports/{{ sport.code_name }}.png"
                    alt=" {{ 'sport.' + sport.code_name | translate }}"
                    loading="lazy"
                    height="24"
                    width="24"
                />
                {{ 'sport.' + sport.code_name | translate }}
                @if (isDebug) {
                <br /><small class="d-block my-n1"
                    ><span class="text-danger">{{ sport.num_live_matches }}</span> / {{ sport.num_matches }}</small
                >
                } @if (!isDebug && sport.num_live_matches > 0) {
                <div class="table-sport__cell--live app-word-nowrap">
                    {{ 'web.live' | translate }}
                </div>
                } @if (isNew(sport.code_name)) {
                <div class="table-sport__cell--new app-word-nowrap">
                    {{ 'web.new_sport' | translate }}
                </div>
                }
            </a>
        </li>
        }
    </ul>
    }
</div>
} @if (type == 'mobile') {
<nav class="nav flex-column flex-nowrap w-100 bg-white">
    @for (sport of dataRaw; track trackByFn(i, sport); let i = $index) {
    <a
        class="nav-link active"
        style="position: relative"
        routerLinkActive="text-super-emph"
        (click)="resetScroll(); goTo()"
        [routerLink]="this.getRouterArr(sport)"
    >
        <img
            src="/img/sports/{{ sport.code_name }}.png"
            [alt]="'sport.' + sport.code_name | translate"
            loading="lazy"
            class="mr-2"
            height="28"
            width="28"
        />
        {{ 'sport.' + sport.code_name | translate }}
        @if (isDebug) {
        <span class="float-right ml-auto"
            ><span class="text-danger">{{ sport.num_live_matches }}</span> / {{ sport.num_matches }}</span
        >
        } @if (isNew(sport.code_name)) {
        <div class="table-sport__cell--new">
            {{ 'web.new_sport' | translate }}
        </div>
        } @if (!isDebug && sport.num_live_matches > 0) {
        <div
            class="float-right ml-aut table-sport__cell--live"
            style="max-width: fit-content; position: absolute; top: 50%; right: 4%; transform: translateY(-50%)"
        >
            {{ 'web.live' | translate }}
        </div>
        }
    </a>
    }
</nav>
} @if (type == 'aside') { @for (sport of dataRaw | slice : 0 : limit; track trackByFn(i, sport); let i = $index) {
<a
    class="nav-link"
    data-toggle="tooltip"
    data-placement="right"
    [attr.data-cy]="sport.code_name"
    title="{{ 'sport.' + sport.code_name | translate }}"
    [class.active]="sport.id == sportId"
    [ngStyle]="{ 'pointer-events': disabled ? 'none' : null }"
    (click)="resetScroll()"
    [routerLink]="this.getRouterArr(sport)"
>
    <img
        src="/img/sports/{{ sport.code_name }}.png"
        alt="{{ 'sport.' + sport.code_name | translate }}"
        loading="lazy"
        width="24"
        height="24"
    />
    <span class="sr-only">{{ 'sport.' + sport.code_name | translate }}</span></a
>
} }
